var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedStudentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D7F4C1",
    fillOpacity: 0.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8828_67739)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8828_67739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 14.8C12.6 13.527 13.1057 12.3061 14.0059 11.4059C14.9061 10.5057 16.127 10 17.4 10C18.673 10 19.8939 10.5057 20.7941 11.4059C21.6943 12.3061 22.2 13.527 22.2 14.8C22.2 16.073 21.6943 17.2939 20.7941 18.1941C19.8939 19.0943 18.673 19.6 17.4 19.6C16.127 19.6 14.9061 19.0943 14.0059 18.1941C13.1057 17.2939 12.6 16.073 12.6 14.8ZM9 28.0863C9 24.3925 11.9925 21.4 15.6862 21.4H19.1137C22.8075 21.4 25.8 24.3925 25.8 28.0863C25.8 28.7013 25.3012 29.2 24.6862 29.2H10.1137C9.49875 29.2 9 28.7013 9 28.0863ZM32.4375 16.6375L27.6375 21.4375C27.285 21.79 26.715 21.79 26.3662 21.4375L23.9662 19.0375C23.6137 18.685 23.6137 18.115 23.9662 17.7663C24.3187 17.4175 24.8887 17.4138 25.2375 17.7663L27 19.5288L31.1625 15.3625C31.515 15.01 32.085 15.01 32.4338 15.3625C32.7825 15.715 32.7862 16.285 32.4338 16.6337L32.4375 16.6375Z",
    fill: "#36907E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8828_67739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(9 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8828_67739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedStudentsIcon);
export default __webpack_public_path__ + "static/media/VerifiedStudentsIcon.b551c9d223ab92204c91a50e071368e5.svg";
export { ForwardRef as ReactComponent };